// React
import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material UI
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
// Styles
import { useStyles } from 'components/tables/UserActionsTable/UserActionsTable.style';
// PCP Components
import OnMousePopover from 'components/commons/OnMousePopover';
// Facade
import Facade from 'core/Facade';

const UserActionsTable = ({ actionRecords }) => {
    const classes = useStyles();

    return (
        <Paper className={classes.root}>
            <Table className={classes.table} size='medium' aria-label='a dense table'>
                <TableHead sx={{ height: '60px' }}>
                    <TableRow>
                        <TableCell className={classes.tableHeadCell}>Date</TableCell>
                        <TableCell className={classes.tableHeadCell} align='left'>{translate.i18n('USER')}</TableCell>
                        <TableCell className={classes.tableHeadCell} align='left'>{translate.i18n('ACCOUNTS')}</TableCell>
                        <TableCell className={classes.tableHeadCell} align='left'>{translate.i18n('ACTION_TYPE')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {actionRecords.map((record, key) =>
                        <TableRow key={key}>
                            <TableCell component='th'>
                                {Facade.formatDate(new Date(record.date))}
                            </TableCell>
                            <TableCell align='left'>{record.user}</TableCell>
                            <TableCell align='left'>{record.superUser ? translate.i18n('SUPER_USER') : record.accounts.length > 1 ? <OnMousePopover text={translate.i18n('MULTIPLE_ACCOUNTS')}>{record.accounts.map(a => <Typography key={a}>{a}</Typography>)}</OnMousePopover> : record.accounts[0]}</TableCell>
                            <TableCell align='left'>{record.action}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper >
    );
};

UserActionsTable.propTypes = {
    actionRecords: PropTypes.array
};

export default UserActionsTable;
